import React from 'react'
import PageTitle from '../Utilities/PageTitle'

export default function Partners() {
    return <>
        <div className="main-content-area">
            {/* <!-- Section: page title --> */}
            <PageTitle title='Partners' homeLink='/' homePage='Home' currentLink='/our-parnters' />
            <section>
                <div className="container pt-5">
                    <div className="section-content">
                        <div className="row">
                            <h2 className="line-bottom line-bottom-theme-colored1">Our <span className="text-theme-colored1">Partners</span></h2>

                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <div className="upcoming-events-current-style mb-10 mb-sm-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/1.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                                <div className="upcoming-events-current-style mb-10 mb-sm-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/2.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                                <div className="upcoming-events-current-style mb-10 mb-md-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/3.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <div className="upcoming-events-current-style mb-10 mb-sm-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/1.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                                <div className="upcoming-events-current-style mb-10 mb-sm-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/2.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                                <div className="upcoming-events-current-style mb-10 mb-md-40">
                                    <div className="row align-items-center">
                                        <div className="col-sm-3 pr-0 pr-sm-15">
                                            <div className="thumb">
                                                <img className="w-100" src="images/event/3.jpg" alt="..." />
                                            </div>
                                        </div>
                                        <div className="col-sm-8">
                                            <div className="event-details p-15 pt-0 pb-0">
                                                <h5 className="media-heading text-uppercase mt-0 mb-0 mt-sm-15">Upcoming Event Title</h5>

                                                <p className="mb-10">Dignissim cras tincidunt lorem ipsum is simply free text feugiat at augue. Id purus integer orci.</p>

                                            </div>
                                        </div>
                                        <div className="col"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </>
}
